import { runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { stringify } from 'qs';
import * as React from 'react';
import { Button, IButtonProps } from 'telia-front-react';
import config from '../Config';
import CookieConsentStore from '../stores/CookieConsentStore';
import LanguageStore from '../stores/LanguageStore';
import RouteStore from '../stores/RouteStore';
import SsoStore from '../stores/SsoStore';

export type LogInButtonProps = IButtonProps & {
  url?: string;
  urlParams?: string[];
  selectMandate?: boolean;
  ssoStore?: SsoStore;
  languageStore?: LanguageStore;
  cookieConsentStore?: CookieConsentStore;
  routeStore?: RouteStore;
  isNode?: boolean;
};

interface LogInButtonState {
  logInUrl: string;
}

@observer
class LogInButton extends React.Component<LogInButtonProps, LogInButtonState> {
  constructor(props: LogInButtonProps | Readonly<LogInButtonProps>) {
    super(props);
    this.state = { logInUrl: '' };
  }

  componentDidMount() {
    this.setState({ logInUrl: this.getUrl() });
  }

  private handleClick = (event?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    runInAction(() => {
      const { selectMandate, ssoStore, onClick } = this.props;

      if (onClick) {
        onClick(event);
      }

      if (!(event.ctrlKey || event.metaKey || event.shiftKey)) {
        event.preventDefault();
        const url = this.getUrl();
        ssoStore.ensureLogin(url.includes('goto=') ? url.split('goto=')[1] : url, null, selectMandate === undefined ? true : selectMandate);
      }
    });
  };

  private getButtonProps() {
    const buttonProps = { ...this.props };
    delete buttonProps.onClick;
    return buttonProps;
  }

  private getParamsFromCurrentUrl() {
    const {
      routeStore: { decodedParams },
      urlParams
    } = this.props;

    return urlParams ? stringify(decodedParams, { filter: urlParams }) : '';
  }

  private getUrl() {
    const {
      languageStore: { currentLanguage },
      cookieConsentStore,
      selectMandate
    } = this.props;
    let url = this.props.url || window.location.href;
    const urlParams = this.getParamsFromCurrentUrl();
    url = url + (urlParams && (url.includes('?') ? `&${urlParams}` : `?${urlParams}`));
    if (this.props.ssoStore.loggedIn) {
      return url;
    } else {
      return `${config.ssoClientUrl}?authlevel=2&selectMandate=${
        selectMandate === undefined ? true : selectMandate
      }&locale=${currentLanguage}&allowStatisticsCookies=${cookieConsentStore?.cookieConsents?.statistics || false}&goto=${url}`;
    }
  }

  public render() {
    if (!this.props.url && this.props.ssoStore.loggedIn) {
      return null;
    }
    // @ts-ignore
    return <Button onClick={this.handleClick} {...this.getButtonProps()} url={this.props.isNode ? this.getUrl() : this.state.logInUrl} />;
  }
}

export default inject('ssoStore', 'languageStore', 'cookieConsentStore', 'routeStore', 'isNode')(LogInButton);
